import { createFileRoute } from "@tanstack/react-router";
import { ProductionContainer } from "@/features/production";

export const Route = createFileRoute("/$store/_layout/production")({
	component: ProductionPage,
});

function ProductionPage() {
	return <ProductionContainer />;
}
